import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SecondaryButton } from 'components';
import * as styles from './EmptyState.scss';

var EmptyState = /*#__PURE__*/function (_Component) {
  _inherits(EmptyState, _Component);

  var _super = _createSuper(EmptyState);

  function EmptyState() {
    _classCallCheck(this, EmptyState);

    return _super.apply(this, arguments);
  }

  _createClass(EmptyState, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.emptyStateWrap,
        style: this.props.style
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.text,
        style: this.props.textStyle
      }, this.props.text), /*#__PURE__*/React.createElement("i", {
        className: "text icon ".concat(this.props.iconName, " ").concat(styles.icon),
        style: this.props.iconStyle ? this.props.iconStyle : {
          fontSize: this.props.iconSize
        }
      }), !!this.props.subtext && /*#__PURE__*/React.createElement("span", {
        style: {
          paddingBottom: 20
        }
      }, this.props.subtext)), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-around',
          flexWrap: 'wrap'
        }
      }, this.props.buttonLabel && !this.props.multipleButtons && /*#__PURE__*/React.createElement(SecondaryButton, {
        label: this.props.buttonLabel,
        onClick: this.props.buttonOnClick
      }), this.props.multipleButtons && !!this.props.buttons && this.props.buttons.map(function (button, index) {
        return /*#__PURE__*/React.createElement(SecondaryButton, {
          key: "emptyStateButton_".concat(index),
          label: button.label,
          onClick: button.onClick,
          style: {
            margin: 24
          },
          disabled: button.disabled
        });
      })));
    }
  }]);

  return EmptyState;
}(Component);

_defineProperty(EmptyState, "propTypes", {
  iconName: PropTypes.string,
  text: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonOnClick: PropTypes.any,
  iconSize: PropTypes.any
});

_defineProperty(EmptyState, "defaultProps", {
  iconSize: '75px',
  style: {},
  multipleButtons: false,
  iconStyle: null,
  textStyle: {},
  buttonLabel: null
});

export default EmptyState;